export function optional( chance: number = 50 ) { return Math.random() < ( chance / 100 ); }
